export default "__VITE_ASSET__6JBdOwwl__"